import styled from 'styled-components'

import Button from './Button'

const IconButton = styled(Button)`
  padding: 7.5px;

  svg {
    margin: 0;
  }
`

export default IconButton
